import { render, staticRenderFns } from "./AdminUserStatPanel.vue?vue&type=template&id=8f962cd2&scoped=true&lang=pug&"
import script from "./AdminUserStatPanel.vue?vue&type=script&lang=js&"
export * from "./AdminUserStatPanel.vue?vue&type=script&lang=js&"
import style0 from "./AdminUserStatPanel.vue?vue&type=style&index=0&id=8f962cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f962cd2",
  null
  
)

export default component.exports